var _path, _circle, _circle2, _line, _line2, _line3, _line4, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoDelivery24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.333 11.6665V20.9998C30.333 22.2885 31.3777 23.3332 32.6663 23.3332H48.9997",
    fill: "none",
    strokeWidth: 4.66667,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 39.6662,
    cy: 41.9997,
    r: 4.66667,
    fill: "none",
    strokeWidth: 4.66667,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3332,
    cy: 41.9997,
    r: 4.66667,
    fill: "none",
    strokeWidth: 4.66667,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23.3328,
    y1: 41.9997,
    x2: 32.6662,
    y2: 41.9997,
    fill: "none",
    strokeWidth: 4.66667,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 6.99984,
    y1: 23.3332,
    x2: 16.3332,
    y2: 23.3332,
    fill: "none",
    strokeWidth: 4.66667,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 4.66634,
    y1: 41.9997,
    x2: 9.33301,
    y2: 41.9997,
    fill: "none",
    strokeWidth: 4.66667,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 11.6663,
    y1: 16.3332,
    x2: 20.9997,
    y2: 16.3332,
    fill: "none",
    strokeWidth: 4.66667,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.333 9.33301H38.5735C39.266 9.33301 39.9227 9.64059 40.366 10.1726L50.6846 22.5549C51.0982 23.0513 51.2875 23.6969 51.2074 24.3381L49.2552 39.9558C49.1092 41.1234 48.1166 41.9997 46.9399 41.9997H46.6663",
    fill: "none",
    strokeWidth: 4.66667,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDelivery24);
export default __webpack_public_path__ + "static/media/ico-delivery-24.0d57decb.svg";
export { ForwardRef as ReactComponent };